import { gql } from 'apollo-angular';

/**
 * Queries related to driving restrictions.
 */
export class RestrictionsQueries {
  public static getAllRestrictions = gql`
    query drivingRestrictionGetRestrictionsQuery($vehicleName: String) {
      drivingRestrictionGetRestrictions(vehicleName: $vehicleName) {
        restrictionId
        displayName
        restrictionName
        dateCreated
        dateUpdated
        validFrom
        validTo
        banTestTrack
        banPublicRoad
        cause
        risk
        consequence
        precondition
        operatedRestriction
        removingCondition
        additionalInformation
        modifiedBy
        createdBy
        links
        responsible
        approvedBy
        fileUids {
          fileUid
        }
        active
        vehicles {
          vinNo
          name
        }
        fpcs {
          fpcId
          name
          category
          regTime
        }
      }
    }
  `;

  public static getArchivedRestrictions = gql`
    query drivingRestrictionGetArchivedQuery {
      drivingRestrictionGetArchived {
        restrictionId
        displayName
        restrictionName
        dateCreated
        dateUpdated
        validFrom
        validTo
        banTestTrack
        banPublicRoad
        cause
        risk
        consequence
        precondition
        operatedRestriction
        removingCondition
        additionalInformation
        modifiedBy
        createdBy
        links
        responsible
        approvedBy
        fileUids {
          fileUid
        }
        active
        vehicles {
          vinNo
          name
        }
        fpcs {
          fpcId
          name
          category
          regTime
        }
      }
    }
  `;

  public static getAllFpcsWithRestrictions = gql`
    query drivingRestrictionGetFpcRestrictions {
      drivingRestrictionGetFpcRestrictions {
        fpcId
        name
        category
        regTime
        restrictions {
          restrictionId
          displayName
          restrictionName
          dateCreated
          dateUpdated
          validFrom
          validTo
          banTestTrack
          banPublicRoad
          cause
          risk
          consequence
          precondition
          operatedRestriction
          removingCondition
          additionalInformation
          modifiedBy
          createdBy
          links
          responsible
          approvedBy
          fileUids {
            fileUid
          }
          active
          vehicles {
            vinNo
            name
          }
          fpcs {
            fpcId
            name
            category
            regTime
          }
        }
      }
    }
  `;

  public static getAllVehiclesWithRestrictions = gql`
    query drivingRestrictionGetVehicleRestrictions {
      drivingRestrictionGetVehicleRestrictions {
        vinNo
        name
        restrictions {
          restrictionId
          displayName
          restrictionName
          dateCreated
          dateUpdated
          validFrom
          validTo
          banTestTrack
          banPublicRoad
          cause
          risk
          consequence
          precondition
          operatedRestriction
          removingCondition
          additionalInformation
          modifiedBy
          createdBy
          links
          responsible
          approvedBy
          fileUids {
            fileUid
          }
          active
        }
      }
    }
  `;

  public static retrieveFileInfo = gql`
    query fileHandlerDrivingRestrictionRetrieveFileInfo($FileUid: String!) {
      fileHandlerDrivingRestrictionRetrieveFileInfo(FileUid: $FileUid) {
        FileName
        FileUid
      }
    }
  `;

  public static generatePresignedDownloadUrl = gql`
    query fileHandlerDrivingRestrictionGeneratePresignedDownloadUrl($FileUid: String!) {
      fileHandlerDrivingRestrictionGeneratePresignedDownloadUrl(FileUid: $FileUid)
    }
  `;

  public static uploadFile = gql`
    mutation fileHandlerDrivingRestrictionUploadFile($FileName: String!, $Source: String!) {
      fileHandlerDrivingRestrictionUploadFile(FileName: $FileName, Source: $Source) {
        FileUid
        PreSignUrl
      }
    }
  `;

}
